import { observer } from 'mobx-react-lite'
import { Icon, Typography } from 'shared/ui'
import { AudioPlayer } from 'shared/ui/AudioPlayer'
import { type Attachment } from 'entities/Attachment/model/Attachment'
import { sentEventSentry } from 'entities/Sentry'
import styles from './styles.module.scss'

export const MessageRinglessPreview = observer(
  ({
    attachment,
    isShowAttachmentName,
  }: {
    attachment: Attachment | null
    isShowAttachmentName?: boolean
  }) => {
    return (
      <div className={styles.wrap}>
        <div className={styles.header}>
          <Typography
            ariaLabel={'Ringless'}
            variant={'body-md-medium'}
            className={styles.title}
            tag={'div'}
            ellipsis
          >
            {isShowAttachmentName && attachment?.name ? attachment.name : 'Ringless'}
          </Typography>
          <div className={styles.icon}>
            <Icon icon={'voicemail'} fontSize={12} />
          </div>
        </div>
        {attachment && !attachment.loading ? (
          <div className={styles.wrapPlayer}>
            <AudioPlayer
              url={attachment.source}
              duration={attachment.duration}
              fullWidth
              size={'small'}
              onError={(error) => {
                sentEventSentry({
                  event: '[Audio] MessageRinglessPreview - error',
                  name: 'audio:error',
                  level: 'error',
                  error: error,
                })
              }}
            />
          </div>
        ) : (
          <Typography
            ariaLabel={'placeholder'}
            variant={'body-md-regular'}
            className={styles.placeholder}
            tag={'div'}
          >
            Add an audio
          </Typography>
        )}
      </div>
    )
  }
)
